<div class="container-devis">
  <h2 class="secondary-color">MON ESPACE</h2>
  <h3>Mes Informations</h3>
  <div class="container-fil-ariane">
    <ags-fil-ariane [name]="'Mon espace'" [link]="'/account'"></ags-fil-ariane>
    <p class="space-fil-ariane">></p>
    <ags-fil-ariane [name]="'Mes informations'" [link]="'/mesinformations'"></ags-fil-ariane>
  </div>
</div>
<div class="container-informations">
  <div class="flex">
    <span class="small-padding-informations"><b>Je suis :</b></span>
    <kendo-dropdownlist
      [data]="listTypeClient"
      [(value)]="typeClient"
      (selectionChange)="clientTypeChange($event)"
      class="selection-form-individual-company"
    >
    </kendo-dropdownlist>
  </div>
  <div class="company-block-informations" *ngIf="typeClient === 'responsable de formation'">
    <form [formGroup]="formCompanyInformations" *ngIf="!!typeClient" (ngSubmit)="formUpdateCompany()">
      <!-- Formulaire Infos Organisation -->

      <div class="container-block-form-informations">
        <h5>Informations de l'organisation</h5>

        <div class="row-informations">
          <div class="column-errors-input">
            <input
              id="ime"
              kendoTextBox
              [placeholder]="'Nom de l\'organisation'"
              formControlName="raisonSociale"
              class="input-informations"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formCompanyInformations.get('raisonSociale').invalid && submitted"
            >
              Veuillez renseigner le nom de l'organisation
            </div>
          </div>
        </div>

        <div class="container-input-combobox">
          <div class="input-column">
            <div class="column-errors-input-combobox">
              <kendo-combobox
                [data]="listTypeEntreprise"
                [textField]="'libelle'"
                [valueField]="'id'"
                [placeholder]="'Type d\'entreprise*'"
                formControlName="typeEntreprise"
                class="input-combobox"
              >
              </kendo-combobox>
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('typeEntreprise').invalid && submitted"
              >
                Veuillez renseigner le type d'entreprise
              </div>
            </div>
          </div>
          <div class="input-column">
            <div class="column-errors-input-combobox">
              <input
                kendoTextBox
                (keyup)="onKey($event)"
                [placeholder]="'SIREN / SIRET*'"
                formControlName="siret"
                class="informations-combobox-input"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('siret').invalid && submitted"
              >
                Numéro de SIRET/SIREN invalide
              </div>
            </div>
          </div>
        </div>

        <div class="row-informations">
          <div class="column-errors-input">
            <input
              kendoTextBox
              [placeholder]="'TVA intracommunautaire*'"
              formControlName="tva"
              name="tva"
              class="input-informations"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formCompanyInformations.get('tva').invalid && submitted"
            >
              Veuillez renseigner votre TVA
            </div>
          </div>
        </div>

        <div class="block-validation-informations">
          <div class="validation-informations" [innerHTML]="rgpd">
            <!-- MODIFIER L'ENCODAGE POUR LES ACCENS ET AUTRE -->

            <!--TODO REMOVE Commentaire when CGV function avaible -->
            <!--<input formControlName="cgv" type="checkbox" id="cdc1" class="k-checkbox" />-->
            <!--<label-->
            <!--[ngClass]="-->
            <!--submitted && formCompanyInformations.get('cgv').invalid-->
            <!--? 'errors-profile-informations alert-color k-checkbox-label font-size-16'-->
            <!--: 'k-checkbox-label'-->
            <!--"-->
            <!--for="cdc1"-->
            <!--&gt;-->
            <!--Je valide les <a (click)="getCGV()" title="conditions générales<">&nbsp;conditions générales&nbsp; </a> de-->
            <!--vente.-->
            <!--</label>-->
          </div>

          <div class="validation-informations">
            <button kendoButton>
              <ng-container *ngIf="!loading; else buttonSubmitted">
                Valider
              </ng-container>
              <ng-template #buttonSubmitted>
                Chargement...
              </ng-template>
            </button>
          </div>
        </div>

        <!-- Formulaire Infos Responsable -->
      </div>
      <div class="container-block-form-informations">
        <h5>informations du responsable</h5>
        <div class="container-two-column">
          <div class="column-errors-input">
            <kendo-combobox [data]="listCiv" [placeholder]="'Civ.'" formControlName="civ" class="civility-informations">
            </kendo-combobox>
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formCompanyInformations.get('civ').invalid && submitted"
            >
              Veuillez renseigner votre civilité
            </div>
          </div>
          <div class="column-errors-input">
            <input kendoTextBox [placeholder]="'Nom'" formControlName="nom" />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formCompanyInformations.get('nom').invalid && submitted"
            >
              Veuillez renseigner votre nom
            </div>
          </div>
          <div class="column-errors-input">
            <input kendoTextBox [placeholder]="'Prénom'" formControlName="prenom" />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formCompanyInformations.get('prenom').invalid && submitted"
            >
              Veuillez renseigner votre prénom
            </div>
          </div>
        </div>
        <div class="container-two-column">
          <div class="column-errors-input">
            <input kendoTextBox [placeholder]="'Fonction'" formControlName="role" />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formCompanyInformations.get('role').invalid && submitted"
            >
              Veuillez renseigner votre fonction
            </div>
          </div>
          <div class="column-errors-input">
            <input kendoTextBox [placeholder]="'Téléphone'" formControlName="phone" />
            <div class="errors-profile-informations alert-color" *ngIf="formCompanyInformations.get('phone').invalid">
              Veuillez renseigner votre numero de fixe
            </div>
          </div>
          <div class="column-errors-input">
            <input kendoTextBox [placeholder]="'Mobile'" formControlName="mobile" />
            <div class="errors-profile-informations alert-color" *ngIf="formCompanyInformations.get('mobile').invalid">
              Veuillez renseigner votre numéro de portable
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- Formulaire Infos Personnelles -->
  <div *ngIf="typeClient === 'un particulier / indépendant'">
    <form [formGroup]="formUserInformations" *ngIf="!!typeClient" (ngSubmit)="formUpdateUser()">
      <h5>Mes informations</h5>
      <div class="container-three-column">
        <div class="three-input-container">
          <kendo-combobox [data]="listCiv" [placeholder]="'Civ.'" formControlName="civ" class="civility-informations">
          </kendo-combobox>
          <div class="errors-profile-informations alert-color" *ngIf="formUserInformations.get('civ').invalid">
            Veuillez renseigner votre civilité
          </div>
        </div>
        <div class="three-input-container">
          <input kendoTextBox [placeholder]="'Nom'" formControlName="nom" />
          <div class="errors-profile-informations alert-color" *ngIf="formUserInformations.get('nom').invalid">
            Veuillez renseigner votre nom
          </div>
        </div>
        <div class="three-input-container">
          <input kendoTextBox [placeholder]="'Prénom'" formControlName="prenom" />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('prenom').invalid && submitted"
          >
            Veuillez renseigner votre prénom
          </div>
        </div>
      </div>
      <div class="container-three-column">
        <div class="three-input-container">
          <input kendoTextBox [placeholder]="'Fonction'" formControlName="role" />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('role').invalid && submitted"
          >
            Veuillez renseigner votre fonction
          </div>
        </div>
        <div class="three-input-container">
          <input kendoTextBox [placeholder]="'Téléphone'" formControlName="phone" />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('phone').invalid && submitted"
          >
            Veuillez renseigner votre numero de fixe
          </div>
        </div>
        <div class="three-input-container">
          <input class="k-textbox" [placeholder]="'Mobile'" formControlName="mobile" [disabled]="true" />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('mobile').invalid && submitted"
          >
            Veuillez renseigner votre numero de mobile
          </div>
        </div>
      </div>
      <div class="row-informations">
        <div class="column-errors-input">
          <input kendoTextBox [placeholder]="'Adresse'" formControlName="adresse" class="input-informations" />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('adresse').invalid && submitted"
          >
            Veuillez renseigner votre adresse
          </div>
        </div>
      </div>
      <div class="container-two-column">
        <div class="two-input-container">
          <input
            kendoTextBox
            [placeholder]="'Code Postal'"
            formControlName="code_postal"
            class="informations-two-input"
          />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('code_postal').invalid && submitted"
          >
            Veuillez renseigner votre Code Postal
          </div>
        </div>
        <div class="two-input-container">
          <input kendoTextBox [placeholder]="'Ville'" formControlName="ville" class="informations-two-input" />
          <div
            class="errors-profile-informations alert-color"
            *ngIf="formUserInformations.get('ville').invalid && submitted"
          >
            Veuillez renseigner votre ville
          </div>
        </div>
      </div>
      <div class="block-validation-informations">
        <div class="validation-informations">
          <!-- MODIFIER L'ENCODAGE POUR LES ACCENS ET AUTRE -->
          {{ rgpd }}
          <!--TODO REMOVE Commentaire when CGV function avaible -->
          <!--<input formControlName="cgv" type="checkbox" id="cdc2" class="k-checkbox" />-->
          <!--<label-->
          <!--[ngClass]="-->
          <!--submitted && formUserInformations.get('cgv').invalid-->
          <!--? 'errors-profile-informations alert-color k-checkbox-label font-size-16'-->
          <!--: 'k-checkbox-label'-->
          <!--"-->
          <!--for="cdc2"-->
          <!--&gt;-->
          <!--Je valide les <a (click)="getCGV()" title="conditions générales<">&nbsp;conditions générales&nbsp; </a> de-->
          <!--vente.-->
          <!--</label>-->
        </div>
        <div class="validation-informations">
          <button kendoButton>
            <ng-container *ngIf="!loading; else buttonSubmitted"> Valider</ng-container>
            <ng-template #buttonSubmitted>
              Chargement...
            </ng-template>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="example-wrapper">
  <kendo-dialog *ngIf="openeUpdateDialog" (close)="closeDialog()" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center;">
      <ng-container *ngIf="loading && !errorUpdate; else errorUpdateTempleteFormServer">
        <span class="k-icon k-icon k-i-loading primary-color" style="font-size: 64px;"></span>
        <br />
        <br />
        chargement ....
      </ng-container>
      <ng-template #errorUpdateTempleteFormServer>
        <span class="k-icon k-i-close-outline alert-color" style="font-size: 64px;"></span>
        <br />
        <br />
        {{ errorMsg }}
      </ng-template>
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeDialog()" [primary]="true">Ok</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
